import { EfemGatewayHardwareProfileResponseSchema, EfemPeripheralMatrixResponseSchema, PutEfemGatewayHardwareProfileSchema, } from '../../efem-wafer-imaging.schemas.js';
import { CreateEfemClientSchema, GetEfemClientsResponseSchema, TenantDeviceListQuerySchema, TenantDeviceListResponseSchema, } from '../../schemas.js';
import { ProviderEfemTenantGatewayParamSchema, TenantIdParamSchema, } from '../../schemas/params.js';
/** REST contract for `insight-api/src/routes/provider/efem-admin.routes.ts`. */
export const providerEfemContract = {
    getClients: {
        method: 'GET',
        path: '/provider/efem/:tenantId/clients',
        pathParams: TenantIdParamSchema,
        response: GetEfemClientsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get provider EFEM clients',
    },
    updateClient: {
        method: 'PUT',
        path: '/provider/efem/:tenantId/clients/:gatewaySerialNumber',
        pathParams: ProviderEfemTenantGatewayParamSchema,
        body: CreateEfemClientSchema,
        response: GetEfemClientsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update provider EFEM client',
    },
    getHardwareProfile: {
        method: 'GET',
        path: '/provider/efem/:tenantId/clients/:gatewaySerialNumber/hardware-profile',
        pathParams: ProviderEfemTenantGatewayParamSchema,
        response: EfemGatewayHardwareProfileResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get provider EFEM hardware profile',
    },
    putHardwareProfile: {
        method: 'PUT',
        path: '/provider/efem/:tenantId/clients/:gatewaySerialNumber/hardware-profile',
        pathParams: ProviderEfemTenantGatewayParamSchema,
        body: PutEfemGatewayHardwareProfileSchema,
        response: EfemGatewayHardwareProfileResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update provider EFEM hardware profile',
    },
    getPeripheralMatrix: {
        method: 'GET',
        path: '/provider/efem/:tenantId/clients/:gatewaySerialNumber/peripheral-matrix',
        pathParams: ProviderEfemTenantGatewayParamSchema,
        response: EfemPeripheralMatrixResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get provider EFEM peripheral matrix',
    },
    listTenantDevices: {
        method: 'GET',
        path: '/provider/efem/:tenantId/tenant-devices',
        pathParams: TenantIdParamSchema,
        query: TenantDeviceListQuerySchema,
        response: TenantDeviceListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list provider tenant devices',
    },
};
//# sourceMappingURL=provider-efem.contract.js.map